import { UPDATE_FACILITY_STATE } from "../actionTypes"

const initialState = ''

const FacilityUpdateReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case UPDATE_FACILITY_STATE:
            return action.payload

        default: return state
    }
}

export default FacilityUpdateReducer;